import { head } from 'lodash/fp';
import { useQuery } from '@apollo/client/react';

import { GET_HOME_PERK } from './query.gql';
import uniqueContentWithDraftPrecedence from '../../../../../cms/utils/unique-content-with-draft-precedence';

const useGetPerk = (perkId: string) => {
  const response = useQuery(GET_HOME_PERK, {
    variables: { id: perkId },
  });
  const { data } = response;
  return head(uniqueContentWithDraftPrecedence(data?.allMemberPerk));
};

export default useGetPerk;
